module.exports = __webpack_public_path__ + "img/code-error-illustration.0724623d.svg";